import { ProductId } from 'config/products';
import { GeneratedMockup } from 'types/mockups';
import { create } from 'zustand';

export type MockupState = {
  mockups: Partial<Record<ProductId, GeneratedMockup>>;
  isLoading: boolean;
};

type Store = MockupState & {
  setMockups: (mockups: MockupState['mockups']) => void;
  setIsLoading: (isLoading: MockupState['isLoading']) => void;
};

export const useMockupStore = create<Store>()((set) => ({
  mockups: {},
  isLoading: false,
  setMockups: (mockups) => set({ mockups }),
  setIsLoading: (isLoading) => set({ isLoading }),
}));
